import { useState, useEffect } from "react";
// mui
import { Stack, Snackbar, Typography, Slide } from "@mui/material";
import { styled } from '@mui/material/styles';
// components
import Iconify from "../../components/Iconify";
import SvgIconStyle from "../../components/SvgIconStyle";
import DIOText from "../../components/DIOText";
import {
  InvitationLinkDialog,
} from './';
// hooks
import useAuth from '../../hooks/useAuth';

const BlueText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

const SnackbarContent = styled('div')(({ theme }) => ({
  display: 'flex',
  overflow: 'hidden',
  backgroundColor: theme.palette.common.white,
  borderRadius: 16,
  boxShadow: theme.customShadows.card,
  padding: theme.spacing(2, 3),
  color: theme.palette.grey[900],
  textAlign: 'start',
  position: 'relative',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
  '& .snackbar-title': {
    marginRight: theme.spacing(3),
  },
  '& .snackbar-close-icon': {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 24,
    width: 24,
    height: 24,
  }
}));

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

// 한번 닫으면 한 달 동안 다시 띄우지 않기 위한 localStorage 키와 기간
const HIDE_UNTIL_KEY = 'dioBizInvitationNudgeHideUntil';
const HIDE_DURATION_MS = 30 * 24 * 60 * 60 * 1000; // 30일

function isNudgeHidden() {
  if (typeof window === 'undefined') return false;
  try {
    const hideUntil = Number(window.localStorage.getItem(HIDE_UNTIL_KEY));
    return Number.isFinite(hideUntil) && hideUntil > Date.now();
  } catch (e) {
    return false;
  }
}

function hideNudgeForAMonth() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(HIDE_UNTIL_KEY, String(Date.now() + HIDE_DURATION_MS));
  } catch (e) {
    // localStorage 접근 불가 시 무시 (시크릿 모드 등)
  }
}

export default function InvitationNudgeSnackbar({ open, close, keep=false, nudgeID="invitation-nudge-snackbar" }) {
  const { user } = useAuth();
  const [openDialog, setOpenDialog] = useState(false);
  // 한 달 내에 이미 닫은 적이 있으면 숨김 (SSR/hydration 안전을 위해 mount 후 확인)
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setHidden(isNudgeHidden());
  }, []);

  // 닫으면 한 달간 다시 뜨지 않도록 기록
  const dismiss = () => {
    hideNudgeForAMonth();
    setHidden(true);
    close();
  }

  const clickContent = (e) => {
    setOpenDialog(true);
  }

  const closeDialog = () => {
    setOpenDialog(false);
    if (keep) return ;
    dismiss();
  }

  return (
    <>
      <Snackbar
        open={open && !hidden}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
      >
        <SnackbarContent>
          <Stack direction="row" alignItems="center" spacing={1.5} className="snackbar-title">
            <SvgIconStyle src={'/icons/icon-coin-mono.svg'} sx={{ minWidth: '24px', color: "warning.main" }} />
            <Typography
              id={nudgeID}
              variant="subtitle2"
              sx={{ wordBreak: 'keep-all', cursor: 'pointer' }}
              onClick={clickContent}
            >
              {user?.username}님, 동료 기업에 <DIOText />를 추천하면 <BlueText>10만원 할인</BlueText> 받을 수 있어요!
            </Typography>
          </Stack>
          {!keep && (<Iconify icon={'eva:close-fill'} onClick={dismiss} className="snackbar-close-icon" />)}
        </SnackbarContent>
      </Snackbar>
      <InvitationLinkDialog
        open={openDialog}
        close={closeDialog}
      />
    </>
  )
}
